import classNames from "classnames"
import { DropdownCuentasContablesConModal } from "common/components/DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"
import { Dropdown } from "primereact/dropdown"
import "./TarjetaConfiguracion.scss"

export const TarjetaConfiguracion = ({
  header,
  descripcion,
  campos = [],
  cuentas = [],
}: $TSMigrationFixMe) => {
  const HeaderAndDescriccion = () => (
    <>
      <div className='tarjeta-configuracion__titulo'>{header}</div>

      <p>{descripcion}</p>
    </>
  )

  return (
    <div className='tarjeta-configuracion'>
      {campos.length !== 1 && <HeaderAndDescriccion />}

      <div className='row'>
        {campos.length === 1 && (
          <div className='mt-2 col-6'>
            <HeaderAndDescriccion />
          </div>
        )}
        {/* @ts-expect-error TS(7006): Parameter 'campo' implicitly has an 'any' type. */}
        {campos.map((campo) => {
          return (
            <div
              key={`tarjeta-configuracion-${campo.titulo}`}
              className={classNames("col-6 mt-2 p-fluid", {
                "disabled-div": campo.loadingData,
              })}
            >
              <div className='tarjeta-configuracion__titulo-campo'>
                {campo.titulo}
              </div>

              <Dropdown
                value={campo.value}
                options={campo.opciones}
                onChange={(e) => campo.handleSetData(e.value)}
              />
            </div>
          )
        })}
        {/* @ts-expect-error TS(7006): Parameter 'cuenta' implicitly has an 'any' type. */}
        {cuentas.map((cuenta) => {
          return (
            <div
              key={`tarjeta-configuracion-${cuenta.titulo}`}
              className={classNames("col-6 mt-2 p-fluid", {
                "disabled-div": cuenta.loadingCuentas,
              })}
            >
              <div className='tarjeta-configuracion__titulo-campo'>
                {cuenta.titulo}
              </div>
              <DropdownCuentasContablesConModal
                cuentasContablesOptions={cuenta.listaDeCuentas}
                dropdownValue={cuenta.value}
                onChange={cuenta.handleSetData}
                listaDeCuentasBase={cuenta.listaDeCuentasBase}
                cuentaPorDefecto={cuenta.cuentaPorDefecto}
                refreshFetchData={cuenta.refreshFetchData}
                withCreateCuenta={cuenta.withCreateCuenta}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
